import React from 'react';
import { DeliveriesProviders } from './deliveries/DeliveriesProviders';

export const StockTransactionsProviders = ({ children }: any) => {
	return <DeliveriesProviders>{children}</DeliveriesProviders>;
};
